// hooks/useEntityMutation.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";

// Small factory for the "create X -> invalidate list + activities" pattern.
export function useEntityCreateMutation<TPayload, TResult>(
  mutationFn: (payload: TPayload) => Promise<TResult>,
  getInvalidationKeys: (variables: TPayload) => readonly (readonly unknown[])[],
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn,
    onSuccess: (_data, variables) => {
      getInvalidationKeys(variables).forEach((queryKey) =>
        queryClient.invalidateQueries({ queryKey }),
      );
    },
  });
}